import React from "react"
import { Footer } from "./Footer"
import { Header } from "./Header"
import { $isAuth } from "../../store/isAuthStore"
import { useUnit } from "effector-react"

export const Layout = ({ children }) => {
    const isAuth = useUnit($isAuth); 
    return (
        <React.Fragment>
            {isAuth ? <Header /> : null}
            <div className="layout__content">
                {children}
            </div>
            {isAuth ? <Footer /> : null}
        </React.Fragment>
    )
}